import { BasePrice } from './base-price';

export class NormalPrice extends BasePrice {
    constructor(price: number, currency: string) {
        super(price, currency);
    }
}
